import type { AxiosResponse } from "axios";
import { apiClient } from "../clientApi";

export type SurveyUser = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  created_at: string; // ISO string
  session_id: string;
  session_created_at: string;
  course_name: string;
  completed_sessions: number;
  not_completed_sessions: number;
  total_sessions: number;
};

/** Full paginated response */
export type SurveyUsersResponse = {
  page: number;
  items_per_page: number;
  total_records: number;
  total_pages: number;
  sort_by: string;
  sort_direction: string;
  search_term: string | null;
  data: SurveyUser[];
};

export const getSurveyUsers = async (
  org_id: string | number,
  courseName: string,
  page: number | string,
  items_per_page: number | string,
  search?: string
): Promise<SurveyUsersResponse> => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("items_per_page", items_per_page.toString());
  params.append("org_id", org_id.toString());
  params.append("courseName", courseName);
  if (search) params.append("search", search);

  const { data } = await apiClient.get<SurveyUsersResponse, AxiosResponse<SurveyUsersResponse>>(
    `/surveys/survey-users?${params}`
  );

  return data;
};
